import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import UserSearchModal from '#components/o/Chat/UserSearchModal'
import Api from '#services/api'

function AddChatParticipantModal({chatId}) {
  const searchChatParticipant = async userId => {
    try {
      const result = await Api.searchChatParticipant(userId, chatId)
      return {
        user: {
          id: result.id,
          info: result.info,
        },
      }
    } catch (e) {
      switch (e.message) {
        case 'api_get_chat_participant_cannot_add_myself':
          return {
            error: {
              message: i18n.t('search_chat_participant_cannot_add_myself'),
              confirmDisabledReason: i18n.t('search_chat_participant_confirm_disabled_reason_cannot_add_myself'),
            },
          }
        case 'api_get_chat_participant_user_already_in_chat':
          return {
            error: {
              message: i18n.t('search_chat_participant_user_already_in_chat'),
              confirmDisabledReason: i18n.t('search_chat_participant_confirm_disabled_reason_user_already_in_chat'),
            },
          }
        case 'api_get_chat_participant_not_found':
          return {
            error: {
              message: i18n.t('search_chat_participant_not_found', [userId]),
              confirmDisabledReason: i18n.t('search_chat_participant_confirm_disabled_reason_not_found'),
            },
          }
        case 'api_get_chat_participant_bad_request':
          return {
            error: {
              message: i18n.t('api_get_chat_participant_bad_request'),
              confirmDisabledReason: i18n.t('api_get_chat_participant_bad_request'),
            },
          }
        default:
          throw e
      }
    }
  }

  const addParticipant = async userId => {
    try {
      return await Api.addChatParticipant({chatId, participantId: userId})
    } catch (e) {
      actions.error.writeError({error: e})
      throw new Error(i18n.t(e.message))
    }
  }

  const triggerConfig = {
    testId: 'addChatParticipant',
    text: i18n.t('chats_add_participant'),
    buttonVariant: 'secondary',
  }

  const modalConfig = {
    headlineText: i18n.t('chats_add_participant'),
    searchFieldPlaceholder: i18n.t('user_search_field_placeholder'),
    searchResultTitle: i18n.t('user_search_result_found'),
    confirmDisabledReasons: {
      userIdNotValid: i18n.t('search_chat_participant_confirm_disabled_reason_user_id_not_valid'),
      searchInProgress: i18n.t('search_chat_participant_confirm_disabled_reason_search_in_progress'),
      confirmInProgress: i18n.t('search_chat_participant_confirm_disabled_reason_confirm_in_progress'),
    },
    searchCallback: searchChatParticipant,
    confirmCallback: addParticipant,
  }

  return <UserSearchModal triggerConfig={triggerConfig} modalConfig={modalConfig} />
}

AddChatParticipantModal.propTypes = {
  chatId: PropTypes.string.isRequired,
}

export default AddChatParticipantModal
